import Radio from "@mui/material/Radio";
import FormLabel from "@mui/material/FormLabel";
import { blue } from "@mui/material/colors";
import { useGameParamsStore } from "../../../store/gameParams";


export function GameOpenInRadio() {
  const { params, setParams } = useGameParamsStore((state) => state);
  
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setParams({ ...params, newWindow: event.target.value === "false" });
  };

  return (
    <div>
      <FormLabel className="label-padding">Open in</FormLabel>
      <Radio
        name="newWindow"
        value="true"
        id="true"
        checked={!params.newWindow}
        onChange={handleChange}
        sx={{
          color: blue[800],
          "&.Mui-checked": {
            color: blue[600],
          },
        }}
      />
      <span>same window</span>
      <Radio
        name="newWindow"
        value="false"
        id="false"
        checked={params.newWindow}
        onChange={handleChange}
        sx={{
          color: blue[800],
          "&.Mui-checked": {
            color: blue[600],
          },
        }}
      />
      <span>new window</span>
    </div>
  );
}
